import React from "react";
import { connect } from "react-redux";
import { useHistory } from 'react-router-dom';
import PropTypes from "prop-types";
import Logo from "./Logo";
import Menu from "./Menu";
import Wrapper from "./Wrapper";
import MenuMobile from "./MenuMobile";

const Header = (props) => {
  const { isLogin } = props;
  const history = useHistory();
  if (!isLogin) {
    return null;
  }

  return (
    <Wrapper>
      <div className="d-flex flex-row head align-items-center w-full">
        <Logo onClick={() => history.push("/my-application")} src={require("_assets/images/logo-oca-white.svg").default} />
        {/* <span className="title-beta">Beta</span> */}
      </div>
      <Menu isLogin={isLogin} />
      <MenuMobile isLogin={isLogin} />
    </Wrapper>
  );
};

Header.propTypes = {
  isLogin: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    isLogin: state.auth.isLoggedIn,
  };
};

export default connect(mapStateToProps, null)(Header);
